"use client";
import * as React from "react";
const SvgEditSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 12.74V16h3.26l9.61-9.61-3.26-3.26zm16-9.48L12.74 0l-2.2 2.2 3.26 3.27z" }));
export {
  SvgEditSharp as default
};
